import React, { useState, useEffect } from "react";
import { isNumber, reject } from "lodash";
import PropTypes from "prop-types";

// Redux
import { connect } from "react-redux";
import genericAction from "@Actions/generic";

// Utils
import dataHandler from "@Utils/dataHandler";

// Components
import Screen from "@Components/Screen";
import IkTable from "@Components/IkTable";

// Modal
import ConfirmModal from "@Modals/ConfirmModal";
import QuickAnswersCrud from "./Modals/QuickAnswersCrud";

// Styles
import styles from "./styles.module.css";

const QuickAnswers = ({ dispatch, companyName, userName }) => {
	const [tableValue, setTableValue] = useState([]);
	const [openConfirmModal, setOpenConfirmModal] = useState(false);
	const [openQuickAnswersCrud, setOpenQuickAnswersCrud] = useState(false);
	const [filteredItems, setFilteredItems] = useState([]);
	const [profilesList, setProfilesList] = useState([]);
	const [groupsList, setGroupsList] = useState([]);
	const [modalOption, setModalOption] = useState("");
	const [filteredCount, setfilteredCount] = useState(null);
	const [filteredPrintData, setFilteredPrintData] = useState([]);

	const defaultParams = { page: 1, orderKey: "id", orderDir: "desc", rows: 15 };

	useEffect(() => {
		(async () => {
			const quickAnswersPromise = await dataHandler({
				dispatch,
				url: "quickAnswers",
				params: defaultParams,
			});
			const profilesPromise = await dispatch(genericAction({ method: "get", route: "users/all" }));
			const groupsPromise = await dispatch(genericAction({ method: "get", route: "groups/all" }));
			const [quickAnswersResponse, profilesResponse, groupsResponse] = await Promise.all([
				quickAnswersPromise,
				profilesPromise,
				groupsPromise,
			]);

			setfilteredCount(quickAnswersResponse.count);
			setFilteredItems(quickAnswersResponse.items);
			setProfilesList(profilesResponse);
			setGroupsList(groupsResponse);
		})();
	}, []);

	// modal handlers
	const modalData = (name, item) => {
		setTableValue(item);
		setModalOption(name);
		setOpenQuickAnswersCrud(true);
	};
	// Table handlers
	const handlerData = async (params, printable) => {
		const data = await dataHandler({ dispatch, url: "quickAnswers", params });
		if (printable) {
			setFilteredPrintData(data.items);
		} else {
			setFilteredItems(data.items);
			setfilteredCount(data.count);
		}
	};

	// Table handlers
	const handleButtom = (name, item) => {
		switch (name) {
			case "Watch":
				modalData(name, item);
				break;
			case "Edit":
				modalData(name, item);
				break;
			case "Eraser":
				setOpenConfirmModal(true);
				setTableValue(item);
				break;
			case "Add":
				modalData(name, []);
				break;
			default:
				break;
		}
	};
	const apiData = async (name, item) => {
		switch (name) {
			case "Edit": {
				const dataEdit = reject(filteredItems, { id: item.id });
				setFilteredItems([item, ...dataEdit]);
				setOpenQuickAnswersCrud(false);
				break;
			}
			case "Eraser": {
				const dataDelete = await dispatch(genericAction({ method: "delete", route: `quickAnswers/${parseInt(tableValue.id, 10)}` }));
				if (isNumber(dataDelete)) {
					const filteredItemsEraser = reject(filteredItems, { id: dataDelete });
					setFilteredItems(filteredItemsEraser);
				}
				setOpenConfirmModal(false);
				break;
			}
			case "Add":
				setFilteredItems([item, ...filteredItems]);
				break;
			default:
				break;
		}
	};

	return (
		<Screen hasHeader hasSidebar headerTitle="Repuestas Rápidas">
			<div className={styles.container}>
				<div className={styles.containerTableGroup}>
					<div className={styles.tableGroupList}>
						<IkTable
							data={filteredItems}
							columns={[
								{
									label: "Acciones",

									action: [
										{ content: "trash", color: "#b43333", onClick: "Eraser", type: "icon" },
										{ content: "edit", color: "#3f7ea3", onClick: "Edit", type: "icon" },
									],

									dataPosition: "center",
									width: 1,
									canFilter: false,
									canSort: false,
								},
								{
									label: "ID",
									key: "id",
									format: "string",
									dataPosition: "center",
									width: 1,
									canFilter: true,
									canSort: true,
									canPrint: true,
									canExcel: true,
									sortKey: null,
								},
								{
									label: "Hotkey",
									key: "hotkey",
									format: "string",
									width: 1,
									dataPosition: "left",
								},
								{
									label: "Título",
									key: "name",
									format: "string",
									width: 1,
									dataPosition: "left",
								},
								{
									label: "Texto",
									key: "text",
									format: "truncate",
									stringLength: 30,
									width: 2,
									dataPosition: "left",
								},

								{
									label: "Categoría",
									key: "category.name",
									format: "string",
									width: 1,
									dataPosition: "left",
								},
								{
									label: "Grupos",
									format: "arrayTruncate",
									key: "groups,name",
									headerPosition: "left",
									width: 1,
								},
								{
									label: "Usuario",
									key: "user.fullName",
									format: "string",
									dataPosition: "left",
									width: 1,
								},

								{
									label: "Formato",
									key: "type",
									format: "string",
									dataPosition: "left",
									width: 1,
								},
								{
									label: "Usos",
									key: "uses",
									dataPosition: "center",
									format: "blankZero",
									width: 1,
								},
								{
									label: "Adjunto",
									key: "uri",
									headerPosition: "left",
									dataPosition: "left",
									format: "boolean",
									boolLabels: { true: "Si" },
									width: 15,
								},
							]}
							totalRows={filteredCount}
							mobileCardView
							cardLine1={[
								{ key: "id", label: "ID" },
								{ key: "name", label: "" },
							]}
							cardLine2={[
								{ key: "hotkey", label: "Hotkey" },
								{ key: "text", label: "Texto" },
							]}
							cardLine3={[
								{ key: "category.name", label: "Categoría" },
								{ key: "groups,name", label: "Grupos" },
							]}
							cardLine4={[
								{ key: "user.fullName", label: "Usuario" },
								{ key: "type", label: "Formato" },
								{ key: "uri", label: "Adjunto" },
							]}
							filteredPrintData={filteredPrintData}
							defaultParams={defaultParams}
							dataHandler={handlerData}
							handlerTable={handleButtom}
							addButton={{ label: "Agregar" }}
							hidePrintButtons
							searcher={{ width: "40rem", hideOnMobile: true }}
							print={{
								printHeader: { company: companyName, title: "Repuestas Rápidas", user: userName },
							}}
						/>
						{openQuickAnswersCrud && (
							<QuickAnswersCrud
								apiData={apiData}
								tableValue={tableValue}
								modalCrud={modalOption}
								quickAnswersList={filteredItems}
								profilesList={profilesList}
								groupsList={groupsList}
								onClose={() => {
									return setOpenQuickAnswersCrud(false);
								}}
							/>
						)}
					</div>
				</div>
			</div>
			{openConfirmModal && (
				<ConfirmModal
					visible
					icon="exclamation circle"
					header="Confirmar"
					buttonLabel="Eliminar"
					content="Está seguro que desea eliminar el repuestas rápidas"
					focus={tableValue.name}
					onConfirm={() => {
						apiData("Eraser");
					}}
					onDismiss={() => {
						return setOpenConfirmModal(false);
					}}
				/>
			)}
		</Screen>
	);
};
function mapStateToProps({ user, company }) {
	return {
		gruposData: [],
		agentsData: [],
		categoryData: [],
		companyName: company.name,
		userName: user.name,
	};
}

QuickAnswers.propTypes = {
	dispatch: PropTypes.func,
	companyName: PropTypes.string,
	userName: PropTypes.string,
};
export default connect(mapStateToProps)(QuickAnswers);
